/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AdminEmissionsRecordsStatsListProviderWithSourceParameterInner,
    AdminEmissionsRecordsStatsListProviderWithSourceParameterInnerFromJSON,
    AdminEmissionsRecordsStatsListProviderWithSourceParameterInnerToJSON,
} from '../models/AdminEmissionsRecordsStatsListProviderWithSourceParameterInner';
import {
    type NonDetectStats,
    NonDetectStatsFromJSON,
    NonDetectStatsToJSON,
} from '../models/NonDetectStats';
import {
    type PaginatedSiteNonDetectList,
    PaginatedSiteNonDetectListFromJSON,
    PaginatedSiteNonDetectListToJSON,
} from '../models/PaginatedSiteNonDetectList';
import {
    type SiteNonDetect,
    SiteNonDetectFromJSON,
    SiteNonDetectToJSON,
} from '../models/SiteNonDetect';

export interface NondetectsSitenondetectListRequest {
    detectionThreshold?: number;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    page?: number;
    pageSize?: number;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    site?: string;
    timestampAfter?: Date;
    timestampBefore?: Date;
}

export interface NondetectsSitenondetectNonDetectStatsListRequest {
    detectionThreshold?: number;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    site?: string;
    timestampAfter?: Date;
    timestampBefore?: Date;
}

export interface NondetectsSitenondetectRetrieveRequest {
    id: string;
}

/**
 * 
 */
export class NondetectsApi extends runtime.BaseAPI {

    /**
     * Creates request options for nondetectsSitenondetectList without sending the request
     */
    async nondetectsSitenondetectListRequestOpts(requestParameters: NondetectsSitenondetectListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['detectionThreshold'] != null) {
            queryParameters['detection_threshold'] = requestParameters['detectionThreshold'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['timestampAfter'] != null) {
            queryParameters['timestamp_after'] = (requestParameters['timestampAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['timestampBefore'] != null) {
            queryParameters['timestamp_before'] = (requestParameters['timestampBefore'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/nondetects/sitenondetect/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * API endpoint that allows Site NonDetects to be viewed.
     */
    async nondetectsSitenondetectListRaw(requestParameters: NondetectsSitenondetectListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedSiteNonDetectList>> {
        const requestOptions = await this.nondetectsSitenondetectListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedSiteNonDetectListFromJSON(jsonValue));
    }

    /**
     * API endpoint that allows Site NonDetects to be viewed.
     */
    async nondetectsSitenondetectList(requestParameters: NondetectsSitenondetectListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedSiteNonDetectList> {
        const response = await this.nondetectsSitenondetectListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for nondetectsSitenondetectNonDetectStatsList without sending the request
     */
    async nondetectsSitenondetectNonDetectStatsListRequestOpts(requestParameters: NondetectsSitenondetectNonDetectStatsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['detectionThreshold'] != null) {
            queryParameters['detection_threshold'] = requestParameters['detectionThreshold'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['timestampAfter'] != null) {
            queryParameters['timestamp_after'] = (requestParameters['timestampAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['timestampBefore'] != null) {
            queryParameters['timestamp_before'] = (requestParameters['timestampBefore'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/nondetects/sitenondetect/non_detect_stats/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Computes and returns non-detects counts to display on map.
     */
    async nondetectsSitenondetectNonDetectStatsListRaw(requestParameters: NondetectsSitenondetectNonDetectStatsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<NonDetectStats>>> {
        const requestOptions = await this.nondetectsSitenondetectNonDetectStatsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NonDetectStatsFromJSON));
    }

    /**
     * Computes and returns non-detects counts to display on map.
     */
    async nondetectsSitenondetectNonDetectStatsList(requestParameters: NondetectsSitenondetectNonDetectStatsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<NonDetectStats>> {
        const response = await this.nondetectsSitenondetectNonDetectStatsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for nondetectsSitenondetectRetrieve without sending the request
     */
    async nondetectsSitenondetectRetrieveRequestOpts(requestParameters: NondetectsSitenondetectRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling nondetectsSitenondetectRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/nondetects/sitenondetect/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * API endpoint that allows Site NonDetects to be viewed.
     */
    async nondetectsSitenondetectRetrieveRaw(requestParameters: NondetectsSitenondetectRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SiteNonDetect>> {
        const requestOptions = await this.nondetectsSitenondetectRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SiteNonDetectFromJSON(jsonValue));
    }

    /**
     * API endpoint that allows Site NonDetects to be viewed.
     */
    async nondetectsSitenondetectRetrieve(requestParameters: NondetectsSitenondetectRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SiteNonDetect> {
        const response = await this.nondetectsSitenondetectRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
